var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { LegalEntityQueryKey } from './queryKey';
export var useCreateLegalEntity = function () {
    var intl = useIntl();
    var queryClient = useQueryClient();
    var _a = useMutation(function (model) {
        return api.base
            .post('/api/legalentity', model)
            .then(function (res) { return res.data; });
    }, {
        onSuccess: function (result) {
            if (!result)
                return;
            queryClient.setQueryData([LegalEntityQueryKey.LegalEntities], function (old) {
                return old ? __spreadArray(__spreadArray([], old, true), [result], false) : [result];
            });
        },
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
    }), mutateAsync = _a.mutateAsync, isLoading = _a.isLoading;
    return { createLegalEntity: mutateAsync, isLoading: isLoading };
};
